export default {
  onClick: (eventLabel: string) => ({
    event: 'loadEventData',
    eventCategory: 'CTA',
    eventAction: 'Hero Banner',
    eventLabel,
    nonInteractive: false,
    customMetrics: {},
    customVariables: {},
    _clear: true
  }),
  onImpression: (eventLabel: string) => ({
    event: 'loadEventData',
    eventCategory: 'CTA',
    eventAction: 'Hero Banner Impression',
    eventLabel,
    nonInteractive: false,
    customMetrics: {},
    customVariables: {},
    _clear: true
  })
}
